import logo from './logo.svg';
import React, { useState, useEffect } from 'react';
import './LoggedIn/CSS/App.css';
import { auth, signInWithEmailAndPassword } from './firebase';
import Home from './LoggedIn/Home';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Register from './Register'; // Import the Register component
import useAuth from './LoggedIn/Components/useAuth'; // Import the custom hook

import TasksPopup from './LoggedIn/Components/TasksPopup';

function App() {
  const [username, setUsername] = useState(''); // State for username

  const [password, setPassword] = useState('');
  const { isLoggedIn, setIsLoggedIn } = useAuth(); // Use the custom hook
  const [authInitializing, setAuthInitializing] = useState(true); // New state for auth initialization

  const [showTasksPopup, setShowTasksPopup] = useState(false);



  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      setIsLoggedIn(!!user);
      setAuthInitializing(false); // Set to false once we know the auth state
    });

    return () => unsubscribe();
  }, []);
      
  const login = (e) => {
    e.preventDefault();
    const email = `${username}@veryfied.me`; // Construct email from username
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        console.log(userCredential);
        setIsLoggedIn(true);
      })
      .catch((error) => alert(error.message));
  };

  if (authInitializing) {
    return <div>Loading...</div>; // Show loading state while auth is initializing
  }

  return (
    <Router>
      <div className="App">
        <header className="App-header">
      {/**{isLoggedIn && <Header />} */}  
<div style={{height:'25px'}}></div>
          {!isLoggedIn && (
            <>
              <h1>Login / Register</h1>
            </>
          )}
          {/* Routes and other elements */}
          <Routes>
            <Route path="/register" element={<Register />} />

            <Route path="/" element={
              <>
                {isLoggedIn ? (
                  <>
                    {/* Display user interface when logged in */}
                    <Home />
                  </>
                ) : (
                  <div>
                    {/* Login form */}
                    <form onSubmit={login}>
                      <input type="text" value={username} onChange={e => setUsername(e.target.value)} placeholder="Username" />
                      <div></div>
                      <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" />
                      <div></div>
                      <button type="submit">Login</button>
                    </form>
                    <Link to="/register">Go to Register</Link>
                  </div>
                )}
              </>
            } />
          </Routes>
        </header>
       {/** <LogoutButton />*/}
 {/**     {isLoggedIn && <NavBar onToggleTasksPopup={toggleTasksPopup} />} */}
                
                {showTasksPopup && <TasksPopup onClose={() => setShowTasksPopup(false)} />}
{/** <Footer /> */}
      </div>
    </Router>
  );
}

export default App;


